<script setup>
import {Bar} from 'vue-chartjs'
import { CategoryScale, Chart as ChartJS, Filler, LinearScale, LineElement, PointElement, BarElement, TimeSeriesScale, TimeScale } from "chart.js";
import 'chartjs-adapter-dayjs-4/dist/chartjs-adapter-dayjs-4.esm';
ChartJS.register(LinearScale, CategoryScale, LineElement, PointElement, BarElement, Filler, TimeSeriesScale, TimeScale)


const props = defineProps({
  datacollection: {
    type: Object,
    default: () => ({}),
  },
  options: {
    type: Object,
    default: () => ({}),
  }
});
</script>

<template>
  <Bar
    :options="options"
    :data="datacollection"
  />
</template>